import { Group } from '@/shared/ui';
import { GroupInner } from '@/shared/ui';

import { Statement } from './statement';

export const ProofOfAccountStatements = () => {
  return (
    <GroupInner className="mt-5 w-full" size="md">
      <Group>
        <Statement
          title="With banking details"
          description="For invoice and etc."
        />

        <Statement
          title="Without banking details"
          description="For some reason"
        />
      </Group>
    </GroupInner>
  );
};
